import React from "react";
import { RouteObject } from "react-router-dom";
import { ApiClient } from "spry-react/utils/apiClient";

export function manageUsersRoutes(loaderApiClient: ApiClient): RouteObject {
  return {
    path: 'manage-users',
    lazy: async () => {
      const { ManageUsersPage, loader } = await import('./manageUsersPage');
      return {
        element: <ManageUsersPage />,
        loader: () => loader(loaderApiClient),
      };
    },
  };
}

export class ManageUsersUrls 
{
  public static manageUsers() {
    return "/manage-users"
  }
}